// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2570) return "static/chunks/2570-62c56dd39abe1790.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"21":"3c4f7100297f8c62","5318":"3208f807e54ab4a9"}[chunkId] + ".js";
};